<template>
  <div>
    <v-container fluid class="ma-0 px-0 pt-0"
      ><v-row>
        <v-col cols="12" sm="6" md="4" lg="3"
          ><v-card>
            <v-card-title class="pb-0"> Net Liquidity </v-card-title>
            <v-card-title class="pt-1 text-h4">{{ total_equity }}</v-card-title>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="6" md="4" lg="3"
          ><v-card>
            <v-card-title class="pb-0">Profit/Loss Open </v-card-title>
            <v-card-title class="pt-1 text-h4">{{
              total_open_pnl
            }}</v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3"
          ><v-card>
            <v-card-title class="pb-0"> Profit/Loss Total </v-card-title>
            <v-card-title class="pt-1 text-h4">{{
              total_profit_and_loss
            }}</v-card-title>
          </v-card>
        </v-col> -->

        <v-col cols="12" sm="6" md="4" lg="3"
          ><v-card>
            <v-card-title class="pb-0"> Profit/Loss Realized </v-card-title>
            <v-card-title class="pt-1 text-h4">{{
              total_profit_and_loss_realized
            }}</v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3"
          ><v-card>
            <v-card-title class="pb-0"> Positions </v-card-title>
            <v-card-title class="pt-1 text-h4">{{
              sum_all_positions
            }}</v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"><div class="title">Trading Accounts</div> </v-col>
      </v-row>
    </v-container>
    <v-card width="100%">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        :disable-filtering="true"
        item-key="account.name"
        :items-per-page="-1"
        class="elevation-1"
      >
        <template v-slot:[`item.account.name`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                {{ item.account.name }}
              </div>
            </template>
            <span>{{ item?.glue?.config_broker?.name }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.cashBalance.amount`]="{ item }">
          {{ ST.show_as_money_view(get_equity(item)) }}
        </template>
        <template v-slot:[`item.cashBalance.realizedPnL`]="{ item }">
          {{ ST.show_as_money_view(realizedPnL(item.cashBalance)) }}
        </template>
        <template v-slot:[`item.cashBalance.openPnL`]="{ item }">
          {{ ST.show_as_money_view(item?.cashBalance?.openPnL) }}
        </template>
        <template v-slot:[`item.auto_liquidate_threashold_value`]="{ item }">
          {{ get_auto_liquidate_threashold_value(item) }}
        </template>
        <template
          v-slot:[`item.userAccountAutoLiq.dailyLossAutoLiq`]="{ item }"
        >
          {{
            ST.show_as_money_view(item?.userAccountAutoLiq?.dailyLossAutoLiq)
          }}
        </template>
        <template v-slot:[`item.working_orders`]="{ item }">
          {{ working_orders(item) }}
        </template>
        <template v-slot:[`item.filled_orders`]="{ item }">
          {{ filled_orders(item) }}
        </template>
        <template v-slot:[`item.sum_positions`]="{ item }">
          {{ sum_positions(item) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "TradovateAccountsData",
  mixins: [],
  components: {},
  props: {
    users_data: {
      type: Array,
      default: [],
    },
    shared_tr_ws: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Trading Account",
          align: "start",
          value: "account.name",
        },
        {
          text: "Equity",
          value: "cashBalance.amount",
          align: "end",
        },
        // {
        //   text: "Open P/L",
        //   value: "cashBalance.openPnL",
        //   align: "end",
        // },
        {
          text: "Realized P/L",
          value: "cashBalance.realizedPnL",
          align: "end",
          sortable: false,
        },
        // {
        //   text: "Auto Liquidate Threshold Value",
        //   value: "auto_liquidate_threashold_value",
        //   align: "end",
        //   sortable: false,
        // },
        {
          text: "Positions",
          value: "sum_positions",
          align: "center",
          sortable: false,
        },
        // {
        //   text: "Day Loss Limit",
        //   value: "userAccountAutoLiq.dailyLossAutoLiq",
        //   align: "end",
        //   sortable: false,
        // },
        // {
        //   text: "Working orders",
        //   value: "working_orders",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: "Filled orders",
          value: "filled_orders",
          align: "center",
          sortable: false,
        },
      ],
      expanded: [],
      contracts: new Map(),
      fetched_contracts: new Set(),
      symbols_with_positions: new Set(),
      debug: false,
      mock: false,
    };
  },
  methods: {
    get_equity(item) {
      let amount = null;
      if (item?.cashBalance?.amount) {
        amount = item.cashBalance.amount;
      }
      if (amount != null && item?.cashBalance?.openPnL) {
        amount += item.cashBalance.openPnL;
      }

      return amount;
    },
    realizedPnL(item) {
      return item.realizedPnL + item.openPnL;
    },
    get_avg_price(item, data) {
      if (data?.executionReports) {
        let er = data.executionReports.find((o) => {
          return o.orderId == item.id && o.ordStatus === "Filled";
        });
        if (er) {
          return this.ST.show_as_money_view(er.avgPx);
        }
      }
    },
    count_orders(item, status) {
      if (item?.orders) {
        return item.orders.filter((v) => v.ordStatus == status).length;
      }
      return 0;
    },
    working_orders(item) {
      return this.count_orders(item, "Working");
    },
    filled_orders(item) {
      return this.count_orders(item, "Filled");
    },
    fetch_contract(item_tr) {
      if (this.fetched_contracts.has(item_tr.contractId)) {
        return;
      }
      this.fetched_contracts.add(item_tr.contractId);
      let self = this;
      let query = { id: item_tr.contractId };
      this.shared_tr_ws.send({
        url: "contract/item",
        query: query,
        onResponse: function (item) {
          if (self.debug) console.log("contract", item.d);
          if (self.contracts && item?.d?.id) {
            self.contracts.set(item.d.id, item.d);
          }
        },
        onReject: function () {
          self.show_error_message({
            message: `Error fetching contract id "${contract_id}".`,
          });
        },
      });
    },
    get_contract_name(item) {
      let contract = this.contracts.get(item.contractId);
      if (!contract) {
        this.fetch_contract(item);
      }
      if (contract) return contract.name;
      return item.contractId;
    },
    sum_positions(item) {
      if (item?.positions?.length > 0) {
        let pos = item.positions
          .map((v) => (v.netPos > 0 ? v.netPos : 0))
          .reduce((accum, curr) => (curr >= 0 ? accum + curr : accum));
        let neg = item.positions
          .map((v) => (v.netPos < 0 ? v.netPos : 0))
          .reduce((accum, curr) => (curr <= 0 ? accum + curr : accum));
        return `(${pos}, ${neg})`;
      }
      return "(--,--)";
    },
    get_auto_liquidate_threashold_value(item) {
      if (
        item?.accountRiskStatus?.maxNetLiq &&
        item?.userAccountAutoLiq?.trailingMaxDrawdown
      )
        return this.ST.show_as_money_view(
          item.accountRiskStatus.maxNetLiq -
            item.userAccountAutoLiq.trailingMaxDrawdown
        );
      else return "--";
    },
    set_symbols_with_positions(data) {
      data.positions?.forEach((p) => {
        if (p.netPos != 0) {
          this.symbols_with_positions.add(p.contractId);
        }
      });
      data.orders
        ?.filter((v) => v.ordStatus == "Working")
        ?.forEach((o) => {
          this.symbols_with_positions.add(o.contractId);
        });
    },
    calculate_account_open_pnl(positions) {
      let openPnL = positions.reduce(
        (acc, i) => acc + (i?.openPnL ? i.openPnL : 0),
        0
      );
      return openPnL;
    },
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  watch: {},
  computed: {
    items() {
      if (this.mock) {
        let accounts_data = [];
        for (let i = 0; i < 20; i++)
          accounts_data.push({
            account: {
              id: 7278423 + i,
              name: "ELTDE240343246",
              userId: 266203,
              accountType: "Customer",
              active: true,
              clearingHouseId: 2,
              riskCategoryId: 2,
              autoLiqProfileId: 1,
              marginAccountType: "Speculator",
              legalStatus: "Individual",
              archived: false,
              timestamp: "2024-03-25T17:59:04.353Z",
            },
            glue: { config_broker: { name: "any" } },
          });
        return accounts_data;
      }
      if (this.users_data) {
        let accounts_data = [];
        this.symbols_with_positions.clear();
        this.users_data.forEach((data) => {
          data.accounts?.forEach((acc) => {
            let entry = {
              account: acc,
              glue: data.glue,
            };
            entry.userAccountAutoLiq = data.userAccountAutoLiqs?.find(
              (c) => c.id == acc.id
            );
            entry.accountRiskStatus = data.accountRiskStatuses?.find(
              (c) => c.id == acc.id
            );
            entry.cashBalance = data.cashBalances?.find(
              (c) => c.accountId == acc.id
            );
            entry.orders = data.orders?.filter((p) => p.accountId == acc.id);
            entry.executionReports = data.executionReports?.filter(
              (p) => p.accountId == acc.id
            );
            entry.positions = data.positions?.filter(
              (p) => p.accountId == acc.id
            );
            // entry.positions.forEach((p) => {
            //   p.openPnL = 0;
            // });
            entry.cashBalance.openPnL = this.calculate_account_open_pnl(
              entry.positions
            );
            entry.fills = data.fills;
            data.contracts.forEach((c) => this.contracts.set(c.id, c));

            accounts_data.push(entry);
          });
          this.set_symbols_with_positions(data);
        });
        this.$emit(
          "symbol_with_positions",
          this.symbols_with_positions,
          this.contracts
        );
        if (this.debug) console.log("accounts_data", accounts_data);
        return accounts_data;
      } else return [];
    },
    total_open_pnl() {
      let openPnL = this.items.reduce(
        (acc, v) => acc + (v?.cashBalance?.openPnL ? v.cashBalance.openPnL : 0),
        0
      );
      return this.ST.show_as_money_view(openPnL);
    },
    total_profit_and_loss() {
      let realizedPnL = this.items.reduce(
        (acc, v) =>
          acc + (v?.cashBalance?.realizedPnL ? v.cashBalance.realizedPnL : 0),
        0
      );
      let openPnL = this.items.reduce(
        (acc, v) => acc + (v?.cashBalance?.openPnL ? v.cashBalance.openPnL : 0),
        0
      );
      return this.ST.show_as_money_view(realizedPnL + openPnL);
    },
    total_profit_and_loss_realized() {
      let realizedPnL = this.items.reduce(
        (acc, v) =>
          acc + (v?.cashBalance?.realizedPnL ? v.cashBalance.realizedPnL : 0),
        0
      );
      return this.ST.show_as_money_view(realizedPnL);
    },
    total_equity() {
      let amount = this.items.reduce(
        (acc, v) => acc + (v?.cashBalance?.amount ? v.cashBalance.amount : 0),
        0
      );
      let openPnL = this.items.reduce(
        (acc, v) => acc + (v?.cashBalance?.openPnL ? v.cashBalance.openPnL : 0),
        0
      );
      return this.ST.show_as_money_view(amount + openPnL);
    },
    show_data_sum() {
      return this.$vuetify.breakpoint.width > 600;
    },
    sum_all_positions() {
      let pos = 0;
      let neg = 0;
      this.items.forEach((item) => {
        if (item?.positions?.length > 0) {
          pos += item.positions
            .map((v) => (v.netPos > 0 ? v.netPos : 0))
            .reduce((accum, curr) => (curr >= 0 ? accum + curr : accum));
          neg += item.positions
            .map((v) => (v.netPos < 0 ? v.netPos : 0))
            .reduce((accum, curr) => (curr <= 0 ? accum + curr : accum));
        }
      });
      return `(${pos}, ${neg})`;
    },
  },
  mounted() {
    if (this.debug) {
      window.accounts_data_v = this;
    }
  },
};
</script>
